import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import rem from "@/utils/rem";
import "@/assets/css/min.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueCookies from "vue-cookies";
import $ from "jquery";
Vue.prototype.$ = $;
import { initScale } from './utils/scale'
// 初始化适配，假设设计稿为 1920x1080
initScale(1920, 1080)
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { HMCSMACHINECOLLECT } from "./utils/hmcsmachinecollect.js";
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
import moment from "moment";
Vue.prototype.$moment = moment;
Vue.prototype.$HMCSMACHINECOLLECT = HMCSMACHINECOLLECT;
import { Base64 } from "js-base64";
Vue.prototype.$Base64 = Base64;
Vue.use(ElementUI);
Vue.use(rem);
Vue.use(VueCookies);

Vue.prototype.$axios = axios;
Vue.prototype.$cookie = VueCookies;
Vue.config.productionTip = false;
function getUniqueCode() {
  FingerprintJS.load().then((fp) => {
    fp.get().then((result) => {
      const visitorId = result.visitorId;
      console.log("获取设备唯一标识：", visitorId);
      VueCookies.set("uuid", visitorId);
    });
  });
}
// if(!VueCookies.get('SSOID')){
//   getUniqueCode()
// }

router.beforeEach((to, from, next) => {
  if (!VueCookies.get("uuid")) {
    getUniqueCode();
  }
  if (to.meta.noLogin) {
    next();
    return;
  }
  checkLogin(to, next);

  // /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // next()
});
function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return r[2];
  return null;
}
function pcUrl() {
  let geturl = window.location.href;
  let getqyinfo = geturl.split("?")[1];
  let getqys = new URLSearchParams("?" + getqyinfo);
  let getqycode = getqys.get("SSOID");
  return getqycode;
}
function checkLogin(to, next) {
  let SSOID = GetQueryString("SSOID") || pcUrl() || $cookies.get("SSOID");
  var url = "https://sso.chci.cn/ssoJsonLogin.do";
  if (SSOID) {
    console.log("有SSOID", SSOID);
    $cookies.set("SSOID", SSOID, "0"); ///保存请求返回所有信息
    url = "https://sso.chci.cn/ssoJsonLogin.do?ticket=" + SSOID;
  }
  $.ajax({
    //备用请求 和下面的vue-jsop实际效果是一样的  只不过这个是jq
    url: url,
    type: "GET",
    async: false,
    dataType: "jsonp",
    jsonp: "mycallback",
    xhrFields: {
      withCredentials: true, //解决跨服务传递时不传递cookie的问题，允许携带证书
    },
    crossDomain: true, //允许跨域
    timeout: 5000,
    success: function (data) {
      console.log("[ data ] >", data);
      // if(to.meta.noNeedCheckLogin){
      //   next()
      //   return
      // }
      // 不需要登录的界面
      if (
        (data.error && to.meta.noNeedCheckLogin) ||
        (data.error && to.query.noLogin)
      ) {
        next();
        clearLogin();
        return;
      }
      // 没有登录
      if (data.error) {
        clearLogin();
        // 不需要登录
        if (to.meta.noNeedCheckLogin) {
          next();
          return;
        }
        // 去登录界面
        let returnUrl = encodeURIComponent(window.location.href);
        window.location.href =
          "https://sso.chci.cn/login.do?method=get&returnURL=" + returnUrl;
        return;
      }
      console.log(data);
      // 登录了
      setDomainCookie(data);
      gourl(to, next);
    },
  });
}
async function gourl(to, next) {
  await axios
    .get("/apis/hmcsManageService/v2/getAuthority", {
      params: {
        SSOID: $cookies.get("SSOID"),
        userName: $cookies.get("username"),
      },
    })
    .then(({ data }) => {
      console.log(data);
      $cookies.set("goldCard", 0);
      $cookies.set("Wanqi", 0);
      $cookies.set("seniors", 0);
      $cookies.set("dangjian", 0);
      if (data.success) {
        // $cookies.set("isThree", 1);
        data.result.map((item) => {
          if (item.roleName == "金卡入云") {
            $cookies.set("isThree", 1);
            $cookies.set("goldCard", 1);
          } else if (item.roleName == "万企上云") {
            $cookies.set("isThree", 1);
            $cookies.set("Wanqi", 1);
          } else if (item.roleName == "尊者祥云") {
            $cookies.set("isThree", 1);
            $cookies.set("seniors", 1);
          } else if (item.roleName == "智慧党建") {
            $cookies.set("dangjian", 1);
          }
        });
        // $cookies.set("isThree", data.);
      } else {
        $cookies.set("isThree", 0);
      }
    });

  await axios
    .get("/apis/hmcsManageService/v2/isChciUser", {
      params: {
        SSOID: $cookies.get("SSOID"),
        userName: $cookies.get("username"),
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.code != -1) {
        $cookies.set("ischicn", 1);
      } else {
        $cookies.set("ischicn", 0);
      }
    });
  // 根据云号查询资质审核状态
  await axios
    .get("/apis/hmcsManageService/aptitude/getAptitudeType", {
      params: {
        userName: $cookies.get("username"),
        SSOID: $cookies.get("SSOID"),
      },
    })
    .then(({ data }) => {
      if (data.code == 0) {
        $cookies.set("flairStatus", 0);
        $cookies.set("flairData", JSON.stringify(data.result));
      } else {
        $cookies.set("flairStatus", data.code);
        $cookies.set("flairData", data.message);
        $cookies.set("noPassReason", data.result);
      }
    });
  await axios
    .get("/apis/hmcsManageService/v2/getAgentOrAgency", {
      params: {
        userName: $cookies.get("username"),
        SSOID: $cookies.get("SSOID"),
      },
    })
    .then(({ data }) => {
      $cookies.set("isAgentOrAgency", data.result.isAgentOrAgency);
      $cookies.set("flairArealayer", data.result.areaLayer);
    });
  if (to.meta.noNeedCheckLogin) {
    next();
    return;
  }
  // 不需要权限的页面
  if (
    to.path == "/frontPage" ||
    to.path == "/applyServe" ||
    to.path == "/withdrawManage" ||
    to.path == "/cloudApply"
  ) {
    next();
  } else if (
    to.path == "/flairReview" &&
    $cookies.get("isAgentOrAgency") == "true"
  ) {
    next();
  } else if (
    to.path == "/flairReview" &&
    $cookies.get("isAgentOrAgency") == "false"
  ) {
    next("/frontPage");
  }
  // 无三线至尊 有chci权限
  else if (
    to.path !== "/frontPage" &&
    to.path !== "/applyServe" &&
    $cookies.get("isThree") != "1" &&
    ($cookies.get("ischicn") == "1" || $cookies.get("dangjian") == "1")
  ) {
    // window.location.href =
    //   "http://admin.chci.cn/admin/index.do?SSOID=" +
    //   $cookies.get("SSOID") +
    //   "&ticket=" +
    //   $cookies.get("SSOID");
    window.open("https://hmhdygs.i369.com/", "_self");
  }
  // 权限都有
  else if (
    to.path !== "/frontPage" &&
    to.path !== "/applyServe" &&
    $cookies.get("isThree") == "1" &&
    $cookies.get("ischicn") == "1"
  ) {
    next();
  }
  // 权限都没有
  else if ($cookies.get("isThree") == "0" && $cookies.get("ischicn") == "0") {
    // next("/frontPage");
    // window.location.href('https://hmhdygs.i369.com/')
    window.open("https://hmhdygs.i369.com/", "_self");
  } else if ($cookies.get("ischicn") == "0") {
    window.location.href =
      "https://sso.chci.cn/applyChci.do?SSOID=" +
      $cookies.get("SSOID") +
      "&ticket=" +
      $cookies.get("SSOID");
  }
  // if (isthree && ischicn) {
  //   next();
  // } else if (ischicn && !isthree) {
  //   window.location.href =
  //     "http://admin.chci.cn/admin/index.do?sessionId=" + $cookies.get("SSOID");
  // } else {
  //   next("/home");
  // }
}
function checkNoLogin(to, next) {
  let SSOID = VueCookies.get("SSOID");
  var url = "https://sso.chci.cn/checkLogin.do?ticket=" + SSOID;
  axios.get(url).then(({ data }) => {
    if (data.error) {
      // 根据域名跳转
      let returnUrl = encodeURIComponent(window.location.href);
      window.location.href =
        "https://sso.chci.cn/login.do?method=get&returnURL=" + returnUrl;
      // window.location.href = `https://sso.chci.cn/login.do?method=get&returnURL=${window.location.origin}${window.location.pathname}`;
      return;
    } else {
      setLoginStoreState(data);
      next();
    }
  });
}
function setDomainCookie(data) {
  console.log("77777777777777777", data);
  store.state.userinfo = data;
  $cookies.set("SSOID", data.ticketVo.ticketEncryptKey, "0"); ///保存请求返回所有信息
  $cookies.set("kqlayer", data.user.kqlayer, "0"); ///保存请求返回所有信息
  $cookies.set("username", data.ticketVo.username, "0"); ///保存请求返回所有信息
  $cookies.set("isLogin", true, "0"); ///保存请求返回所有信息
  $cookies.set("loginName", data.user.name, "0"); ///保存请求返回所有信息
  setDomainStoreState();
}

function setDomainStoreState() {
  store.state.isLogin = $cookies.get("isLogin");
  store.state.SSOID = $cookies.get("SSOID"); //所属管理地区
  store.state.username = $cookies.get("username"); //保存请求返回所有信息
}
function clearLogin() {
  store.state.isLogin = false;
  store.state.cookie = "";
  store.state.userinfo = {};
  store.state.userName = "";
  clearDomain();
}
function clearDomain() {
  $cookies.remove("isLogin");
  // $cookies.remove("SSOID");
  $cookies.remove("username");
  $cookies.remove("areaLayer");
  $cookies.remove("isThree");
  $cookies.remove("ischicn");

  store.state.isLogin = $cookies.get("isLogin"); //所属管理地区
  store.state.SSOID = $cookies.get("SSOID"); //保存请求返回所有信息
  store.state.username = $cookies.get("username"); //保存地区编码
  store.state.areaLayer = $cookies.get("areaLayer"); //保存地区编码
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
